import { render, staticRenderFns } from "./ContactProjects.vue?vue&type=template&id=3595f06c&scoped=true&"
import script from "./ContactProjects.vue?vue&type=script&lang=js&"
export * from "./ContactProjects.vue?vue&type=script&lang=js&"
import style0 from "./ContactProjects.vue?vue&type=style&index=0&id=3595f06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3595f06c",
  null
  
)

export default component.exports